/**
 * Provider currency mappings
 * Maps provider names to their supported currencies
 * Based on provider_currencies.csv
 *
 * Optimized structure: Direct map with pre-sorted currencies and O(1) case-insensitive lookup
 */

type ProviderCurrencyMap = Record<string, readonly string[]>;

// Direct provider-to-currencies mapping (pre-sorted for consistency)
// Currencies are sorted: DOP, GTQ, HNL, USD
const PROVIDER_CURRENCIES: ProviderCurrencyMap = {
  '1x2gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  '100HP Gaming': ['GTQ', 'HNL', 'USD'],
  '155.io': ['USD'],
  '3Oaks': ['DOP', 'GTQ', 'HNL', 'USD'],
  '7777Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  AASexy: ['USD'],
  'Alchemy Gaming': ['DOP', 'USD'],
  All41: ['DOP', 'USD'],
  Amusnet: ['USD'],
  'Animo Live': ['USD'],
  'Apparat Gaming': ['USD'],
  'Atomic Slot Lab': ['USD'],
  'Aura Gaming': ['USD'],
  'Aura Gaming Live': ['USD'],
  AvatarUX: ['USD'],
  Aviatrix: ['DOP', 'GTQ', 'HNL', 'USD'],
  Barbarabang: ['GTQ', 'USD'],
  BELATRA: ['USD'],
  'BetGames.TV': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Betrix Games': ['USD'],
  Betsoft: ['USD'],
  BetsyGames: ['USD'],
  BGaming: ['DOP', 'USD'],
  'Big Time Gaming': ['USD'],
  'Bitblox Games': ['USD'],
  Blitzcrown: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Blueprint Gaming': ['USD'],
  Boldplay: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Booming Games': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Brino Games': ['USD'],
  'Buck Stakes Entertainment': ['DOP', 'USD'],
  'Caleta Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  clawbuster: ['GTQ', 'HNL', 'USD'],
  CQ9: ['USD'],
  Creedroomz: ['USD'],
  'Dragon Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  EdgeLabs: ['USD'],
  ElaGames: ['USD'],
  Endorphina: ['USD'],
  'Evolution Gaming': ['USD'],
  'Evoplay Entertainment': ['DOP', 'USD'],
  'Expanse Studios': ['DOP', 'GTQ', 'HNL', 'USD'],
  Ezugi: ['USD'],
  FBastards: ['DOP', 'GTQ', 'HNL', 'USD'],
  Fantasma: ['USD'],
  Fazi: ['USD'],
  'Felix Gaming': ['DOP', 'GTQ', 'USD'],
  'Flatdog Games': ['DOP', 'GTQ', 'HNL', 'USD'],
  Foxium: ['DOP', 'USD'],
  Fugaso: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Fun Fiesta': ['DOP', 'GTQ', 'HNL', 'USD'],
  'G Games': ['DOP', 'GTQ', 'HNL', 'USD'],
  Galaxsys: ['DOP', 'GTQ', 'HNL', 'USD'],
  GameArt: ['USD'],
  Gameburger: ['DOP', 'USD'],
  'Games Global': ['DOP', 'USD'],
  'Games Inc': ['USD'],
  GamingCorps: ['DOP', 'GTQ', 'HNL', 'USD'],
  Gamomat: ['DOP', 'GTQ', 'HNL', 'USD'],
  Gamzix: ['USD'],
  'Golden Race': ['DOP', 'GTQ', 'HNL', 'USD'],
  H27: ['USD'],
  Habanero: ['DOP', 'USD'],
  'Hacksaw Gaming': ['USD'],
  HalfSquare: ['USD'],
  IGT: ['USD'],
  InOut: ['DOP', 'GTQ', 'HNL', 'USD'],
  'JDB Gaming': ['USD'],
  JFTW: ['DOP', 'USD'],
  Jili: ['USD'],
  'Just Slots': ['USD'],
  'KA Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Kalamba Games': ['DOP', 'USD'],
  Kero: ['USD'],
  KingMidas: ['DOP', 'USD'],
  Konquer: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Leap Gaming Casino': ['DOP', 'GTQ', 'HNL', 'USD'],
  Live88: ['USD'],
  LiveGames: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Lotsaloot Jackpot': ['DOP', 'USD'],
  M2Play: ['USD'],
  'Mancala Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Mascot Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  Microgaming: ['USD'],
  'Microgaming Live': ['USD'],
  'Mount Olympus Arcade Games': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Mount Olympus Cinematic Slots': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Mount Olympus Premium Slots': ['DOP', 'GTQ', 'HNL', 'USD'],
  'NE Games': ['USD'],
  'Neon Valley': ['DOP', 'USD'],
  NetEnt: ['USD'],
  NetGaming: ['DOP', 'USD'],
  'Nolimit City': ['USD'],
  'Northern Lights Gaming': ['DOP', 'USD'],
  Novomatic: ['DOP', 'GTQ', 'HNL', 'USD'],
  Octoplay: ['USD'],
  Odds88: ['USD'],
  OneTouch: ['DOP', 'USD'],
  Onlyplay: ['DOP', 'GTQ', 'HNL', 'USD'],
  Origami: ['USD'],
  'Oryx Gaming': ['USD'],
  PGSoft: ['DOP', 'USD'],
  Pascal: ['USD'],
  'Penguin King': ['USD'],
  'Peter & Sons': ['USD'],
  'Phoenix 7': ['USD'],
  Pickem88: ['USD'],
  Platipus: ['DOP', 'GTQ', 'HNL', 'USD'],
  "Play'n Go": ['DOP', 'GTQ', 'HNL', 'USD'],
  PlayAce: ['USD'],
  Playnetic: ['USD'],
  Playson: ['DOP', 'GTQ', 'HNL', 'USD'],
  Playtech: ['DOP', 'GTQ', 'HNL', 'USD'],
  Playzia: ['DOP', 'GTQ', 'HNL', 'USD'],
  Popiplay: ['USD'],
  Popok: ['USD'],
  'Popok Instant': ['USD'],
  'Pragmatic Play': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Pragmatic Play Live': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Pragmatic Play Virtual Sports': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Print Studios': ['DOP', 'USD'],
  'Push Gaming': ['USD'],
  'RAW iGaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  'RTG Slots': ['USD'],
  'Red Desert': ['USD'],
  'Red Rake Gaming': ['DOP', 'GTQ', 'HNL', 'USD'],
  'Red Tiger Gaming': ['USD'],
  'Relax Gaming': ['DOP', 'USD'],
  'Retro Gaming': ['USD'],
  Rogue: ['USD'],
  RubyPlay: ['USD'],
  'SA Gaming': ['USD'],
  'SKILLEX GAMES': ['USD'],
  ShadyLady: ['USD'],
  SkyWind: ['DOP', 'GTQ', 'HNL', 'USD'],
  Slingshot: ['DOP', 'USD'],
  SlotMatrix: ['USD'],
  'SlotMill Games': ['USD'],
  SmartSoft: ['USD'],
  'Snowborn Studios': ['DOP', 'USD'],
  Solidicon: ['DOP', 'GTQ', 'HNL', 'USD'],
  'Speedy Tomatoes': ['DOP', 'GTQ', 'HNL', 'USD'],
  'SpinPlay Games': ['DOP', 'USD'],
  Spinomenal: ['USD'],
  Spinoro: ['DOP', 'GTQ', 'HNL', 'USD'],
  Spinthon: ['DOP', 'GTQ', 'HNL', 'USD'],
  Spinza: ['USD'],
  'Split The Pot': ['USD'],
  Spribe: ['USD'],
  Stormcraft: ['DOP', 'USD'],
  SwinttGames: ['USD'],
  SwinttPremium: ['USD'],
  ThrillTech: ['USD'],
  Thunderkick: ['USD'],
  'Toka City 2D Player vs Player': ['USD'],
  'Toka City 3D Player vs Player': ['USD'],
  'TopSpin Games': ['USD'],
  TriStar: ['USD'],
  'Triple Edge': ['DOP', 'USD'],
  TrueLab: ['DOP', 'GTQ', 'HNL', 'USD'],
  Turbogames: ['USD'],
  'Victory Ark': ['USD'],
  VivoGaming: ['USD'],
  VoltEnt: ['USD'],
  Wazdan: ['USD'],
  'Wicked Games': ['USD'],
  WinFast: ['USD'],
  Winfinity: ['DOP', 'GTQ', 'HNL', 'USD'],
  ZOOT: ['USD'],
} as const;

// Pre-computed case-insensitive lookup map for O(1) normalization
const CASE_INSENSITIVE_MAP = new Map<string, string>();
Object.keys(PROVIDER_CURRENCIES).forEach((key) => {
  CASE_INSENSITIVE_MAP.set(key.toLowerCase(), key);
});

/**
 * Normalize provider name to match our mapping
 * Uses O(1) lookup for case-insensitive matching
 */
function normalizeProviderName(providerName: string): string {
  // Direct lookup first (exact match) - O(1)
  if (providerName in PROVIDER_CURRENCIES) {
    return providerName;
  }

  // Case-insensitive lookup - O(1) using Map
  return CASE_INSENSITIVE_MAP.get(providerName.toLowerCase()) || providerName;
}

/**
 * Get supported currencies for a provider
 * @param providerName - The provider name from Hub88 game.product
 * @returns Array of supported currency codes (DOP, GTQ, HNL, USD)
 */
export function getProviderCurrencies(providerName: string | null | undefined): readonly string[] {
  if (!providerName) {
    return ['USD']; // Default to USD only
  }

  const normalized = normalizeProviderName(providerName);
  const currencies = PROVIDER_CURRENCIES[normalized];

  if (!currencies || currencies.length === 0) {
    return ['USD']; // Default to USD only if not found
  }

  return currencies; // Already sorted in map
}

/**
 * Check if provider supports only USD
 */
export function isProviderUSDOnly(providerName: string | null | undefined): boolean {
  const currencies = getProviderCurrencies(providerName);
  return currencies.length === 1 && currencies[0] === 'USD';
}

/**
 * Get currency string for database storage (comma-separated)
 */
export function getProviderCurrencyString(providerName: string | null | undefined): string {
  const currencies = getProviderCurrencies(providerName);
  return currencies.join(',');
}

/**
 * Check if provider is mapped in our currency mapping
 * Returns false if provider defaults to USD (unmapped)
 */
export function isProviderMapped(providerName: string | null | undefined): boolean {
  if (!providerName) {
    return false;
  }

  const normalized = normalizeProviderName(providerName);
  return normalized in PROVIDER_CURRENCIES && PROVIDER_CURRENCIES[normalized].length > 0;
}
